import { AUTHORIZATION_INFO } from "@pga/utils/constance/constance";

export enum AuthenticationErrorType {
  Internal,
  External,
  Other,
}

export const authenticationAtomKey = AUTHORIZATION_INFO;

export const Authentication = {
  get: () => JSON.parse(localStorage.getItem(authenticationAtomKey) || "{}"),
  set: (value: any) =>
    localStorage.setItem(authenticationAtomKey, JSON.stringify(value)),
  clear: () => localStorage.removeItem(authenticationAtomKey),
};
